class HttpError extends Error {
    constructor(error) {
        super();
        const {response = {}} = error;
        this.name = "Http Error: ";
        this.status = response.status || null;
        this.data = response.data || {};
    }
}

export default HttpError;
